import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";
import { queryParams } from "../../../utils/helper";

export const hideTemplateApiService = createApi({
  reducerPath: "hideTemplateApi", 
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createHideTemplate: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `hiddentemplate/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getHiddenTemplates: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `hiddentemplate/get${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useCreateHideTemplateMutation, useGetHiddenTemplatesQuery } =
  hideTemplateApiService;
